import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'network-services',
  templateUrl: './network-services.component.html',
  styleUrls: ['./network-services.component.scss']
})
export class NetworkServicesComponent implements OnInit {

  networkServicesItems;

  constructor() {
    this.networkServicesItems = [
      {routerLink: 'syslog', name: 'Syslog'},
      {routerLink: 'ntp', name: 'NTP'},
      {routerLink: 'qos', name: 'QOS'},
      {routerLink: 'cdr', name: 'CDR'},
      {routerLink: 'web-socket', name: 'webSocket'},
    ];
  }

  ngOnInit(): void {
  }

}
